<div class="page-container" animate.enter="route-slide-in-left" animate.leave="route-slide-out-left">
  <div class="page-title-row flex flex-align-center gap-sm mb-md">
    <app-back-button [ariaLabel]="'settings.back' | translate" />
    <h2>{{ 'settings.title' | translate }}</h2>
  </div>

  <div class="settings-nav-list">
    <a app-nav-list-item routerLink="/settings/organization" data-testid="settings-nav-organization">
      <app-icon name="building-2" />
      <span>{{ 'settings.organization.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>

    <a app-nav-list-item routerLink="members" *hasPermission="'user.invite'" data-testid="settings-nav-members">
      <app-icon name="user-plus" />
      <span>{{ 'settings.members.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>

    <a app-nav-list-item routerLink="billing" *hasPermission="'org.billing'" data-testid="settings-nav-billing">
      <app-icon name="credit-card" />
      <span>{{ 'settings.billing.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>

    <a app-nav-list-item routerLink="tags" *hasPermission="'config.manage-lists'" data-testid="settings-nav-tags">
      <app-icon name="tag" />
      <span>{{ 'settings.tags.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>

    <a app-nav-list-item routerLink="services" *hasPermission="'config.manage-lists'" data-testid="settings-nav-services">
      <app-icon name="wrench" />
      <span>{{ 'settings.services.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>

    <a app-nav-list-item routerLink="teams" *hasPermission="'team.manage'" data-testid="settings-nav-teams">
      <app-icon name="users" />
      <span>{{ 'settings.teams.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>

    <a app-nav-list-item routerLink="work-contexts" *hasPermission="'work-context.manage'" data-testid="settings-nav-work-contexts">
      <app-icon name="flag" />
      <span>{{ 'settings.workContexts.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>

    <a app-nav-list-item routerLink="connection" data-testid="settings-nav-connection">
      <app-icon name="wifi" />
      <span>{{ 'settings.connection.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>

    <a app-nav-list-item routerLink="general" data-testid="settings-nav-general">
      <app-icon name="sliders-horizontal" />
      <span>{{ 'settings.general.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>

    @if (isSuperAdmin()) {
    <a app-nav-list-item routerLink="admin" data-testid="settings-nav-admin">
      <app-icon name="shield" />
      <span>{{ 'settings.admin.title' | translate }}</span>
      <app-icon name="chevron-right" class="chevron" />
    </a>
    }
  </div>
</div>
